const { useEffect, useState } = wp.element;

import SyncLoader from 'react-spinners/SyncLoader'

const Component = ({ loadingEmployees, employees, employee, setEmployee, bookingData }) => {
    return (
        <div className="section" id="section-employee">
            <div className="container grid">
                <h2 className="section-title">Velg frisør</h2>

                <>
                    {
                        loadingEmployees &&
                        <div className="loading">
                            <SyncLoader color={'#aaa'} loading={true} size={7} />
                        </div>
                    }

                    {
                        !loadingEmployees &&
                        employees &&
                        employees.length > 0 &&
                        <>
                            <ul className="select-list">
                                {
                                    employees.map((item, key) => {
                                        let price = item.service?.price ? item.service?.price : 0
                                        price = price + (item?.additionalServices?.reduce((a, b) => a + (b?.service?.price || 0), 0) || 0)

                                        return (
                                            <li onClick={() => { setEmployee(item) }} className={`item ${employee?.id === item?.id ? 'active' : ''}`} key={key}>
                                                <div className="radio">
                                                    <div className="dot"></div>
                                                </div>
                                                <div className="text">{item.name}</div>
                                                
                                                {
                                                    price > 0 &&
                                                    typeof price === 'number' &&
                                                    <div className="price">kr {price}</div>
                                                }
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </>
                    }
                    
                    {
                        !loadingEmployees &&
                        employees.length === 0 &&
                        <>
                            <p className="empty-text">
                                Fant ingen tilgjengelige frisører på valgt behandling.
                            </p>
                        </>
                    }
                </>
            </div>
            
            {
                employee &&
                <svg className="progress-arrow" width="64" height="32" viewBox="0 0 64 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0H64L32 32L0 0Z" fill="currentColor"/>
                </svg>
            }
        </div>
    )
}

export default Component;